<template>
  <right-popup
    :show="!!taskId"
    :width="815"
    :border-top="false"
    exclude-footer
    exclude-header-toolbar
    portal-name="task-settings"
    :with-animation="false"
  >
    <template #body>
      <task-settings-main
        :task-id="taskId"
        @close="closeTask"
      />
    </template>
  </right-popup>
</template>

<script>
import RightPopup from '$$vueCmp/popups/rightPopup/rightPopup.vue';
import TaskSettingsMain from './TaskSettingsMain.vue';
import { closeTask } from './helpers';
import app from '$$app';
import LoadRequiredDataMixin from '../../mixins/LoadRequiredData';

export default {
  name: 'TaskSettings',
  components: {
    TaskSettingsMain,
    RightPopup,
  },
  mixins: [LoadRequiredDataMixin],
  props: {
    taskId: {
      type: String,
      required: true,
    },
    parent: {
      type: String,
      default: '',
    },
  },
  computed: {
    showPopup() {
      return this.taskId && this.isLoadedRequiredData;
    },
    getParent() {
      if (this.$route.params.mode === 'list') {
        return 'list';
      }

      return this.parent;
    },
  },
  watch: {
    showPopup: {
      handler(val) {
        if (val) {
          setTimeout(() => {
            this.selectActiveTask(this.taskId);
          }, 0);
        }
      },
      immediate: true,
    },
    taskId: {
      handler(val, oldVal) {
        if (oldVal) {
          setTimeout(() => {
            this.removeActiveTask(oldVal);
          }, 0);
        }
        if (val) {
          setTimeout(() => {
            this.selectActiveTask(val);
          }, 0);
        }
      },
    },
  },
  beforeUnmount() {
    this.removeActiveTask(this.taskId);
  },
  methods: {
    closeTask,
    removeActiveTask(taskId) {
      app.trigger('ganttview:task:unselect');
      app.trigger('gantt:keyboard:enable');
    },
    selectActiveTask(taskId) {
      app.trigger('ganttview:task:select', +taskId);
      app.trigger('gantt:keyboard:disable');
    },
  },

};
</script>

<style scoped lang="less">

@import '../../less/_fonts.less';

</style>
